import React from "react";

import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import ProtectedRoute from "./middlewares/protectedRoute";

import Login from "./pages/login/Login";
import ExpiredToken from "./pages/expiredToken/ExpiredToken";
import HomePage from "./pages/homePage/HomePage";
import PreviewUser from "./pages/tableUsers/PreviewUser";
import CreateUser from "./pages/tableUsers/CreateUser";
import UpdateUser from "./pages/tableUsers/UpdateUser";
import PreviewPromoter from "./pages/tablePromoters/PreviewPromoter";
import CreatePromoter from "./pages/tablePromoters/CreatePromoter";
import UpdatePromoter from "./pages/tablePromoters/UpdatePromoter";
import PreviewSegment from "./pages/tableSegments/PreviewSegment";
import CreateSegment from "./pages/tableSegments/CreateSegment";
import UpdateSegment from "./pages/tableSegments/UpdateSegment";
import { PreviewCancellation } from "./pages/tableCancellations/PreviewCancellation";
import Clients from "./pages/tablePromocode/Client";
import RecoverPassword from "./pages/recoverPassword/RecoverPassword";
import ChangePasswordAccessFirst from "./pages/changePasswordAccessFirst/ChangePasswordAccessFirst";
import { PreviewReportERP } from "./pages/reportERP/PreviewReportERP";
import { PreviewReportFranchisee } from "./pages/reportFranchisee/PreviewReportFranchisee";
import { PreviewReportAccountant } from "./pages/reportAccountant/PreviewReportAccountant";
import PreviewTypePointAccess from "./pages/tableTypesPointAccess/PreviewTypePointAccess";
import CreateTypePointAccess from "./pages/tableTypesPointAccess/CreateTypePointAccess";
import UpdateTypePointAccess from "./pages/tableTypesPointAccess/UpdateTypePointAccess";
import PreviewLocalizationPointAccess from "./pages/tableLocalizationsPointAccess/PreviewLocalizationPointAccess";
import CreateLocalizationPointAccess from "./pages/tableLocalizationsPointAccess/CreateLocalizationPointAccess";
import UpdateLocalizationPointAccess from "./pages/tableLocalizationsPointAccess/UpdateLocalizationPointAccess";
import PreviewFunctionalityPointAccess from "./pages/tableFunctionalitiesPointAccess/PreviewFunctionalityPointAccess";
import CreateFunctionalityPointAccess from "./pages/tableFunctionalitiesPointAccess/CreateFunctionalityPointAccess";
import UpdateFunctionalityPointAccess from "./pages/tableFunctionalitiesPointAccess/UpdateFunctionalityPointAccess";
import { PreviewPointAccess } from "./pages/tablePointsAccess/PreviewPointAccess";
import { CreatePointAccess } from "./pages/tablePointsAccess/CreatePointAccess";
import { UpdatePointAccess } from "./pages/tablePointsAccess/UpdatePointAccess";
import PreviewVideo from "./pages/tableVideos/PreviewVideo";
import PreviewActionPointAccess from "./pages/tableActionsPointAccess/PreviewActionPointAccess";
import CreateActionPointAccess from "./pages/tableActionsPointAccess/CreateActionPointAccess";
import UpdateActionPointAccess from "./pages/tableActionsPointAccess/UpdateActionPointAccess";
import PreviewButtonPointAccess from "./pages/tableButtonsPointAccess/PreviewButtonPointAccess";
import CreateButtonPointAccess from "./pages/tableButtonsPointAccess/CreateButtonPointAccess";
import UpdateButtonPointAccess from "./pages/tableButtonsPointAccess/UpdateButtonPointAccess";
import { ReportLiberations } from "./pages/reportLiberarions/ReportLiberations";
import PreviewCustomer from "./pages/tablePromocode/PreviewCustomer";
import UpdateCustomer from "./pages/tablePromocode/UpdateCustomer";
import { VideoAccountantPreview } from "./pages/marketing/VideoAccountantPreview";
import ContractsPreview from "./pages/contracts/ContractsPreview";
import { ServicePreview } from "./pages/services/ServicePreview";
import { ReportContract } from "./pages/reportContracts/ReportContract";

const Routes = () => {
  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route path="/recoverPassword" component={RecoverPassword} />
          <Route path="/login" component={Login} />
          <Route
            path="/changePasswordAccessFirst"
            component={ChangePasswordAccessFirst}
          />

          <Route path="/expiredToken" component={ExpiredToken} addHeader />

          <ProtectedRoute
            path="/homePage"
            component={HomePage}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewUser"
            component={PreviewUser}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createUser"
            component={CreateUser}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updateUser"
            component={UpdateUser}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewPromoter"
            component={PreviewPromoter}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createPromoter"
            component={CreatePromoter}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updatePromoter"
            component={UpdatePromoter}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewSegment"
            component={PreviewSegment}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createSegment"
            component={CreateSegment}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updateSegment"
            component={UpdateSegment}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewCancellation"
            component={PreviewCancellation}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/clients"
            component={PreviewCustomer}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/oldClients"
            component={Clients}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/updateCustomer"
            component={UpdateCustomer}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewCustomer"
            component={PreviewCustomer}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewReportErp"
            component={PreviewReportERP}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewReportFranchisee"
            component={PreviewReportFranchisee}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewReportAccountant"
            component={PreviewReportAccountant}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewLiberationPortal"
            component={ReportLiberations}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewTypePointAccess"
            component={PreviewTypePointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createTypePointAccess"
            component={CreateTypePointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updateTypePointAccess"
            component={UpdateTypePointAccess}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewLocalizationPointAccess"
            component={PreviewLocalizationPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createLocalizationPointAccess"
            component={CreateLocalizationPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updateLocalizationPointAccess"
            component={UpdateLocalizationPointAccess}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewFunctionalityPointAccess"
            component={PreviewFunctionalityPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createFunctionalityPointAccess"
            component={CreateFunctionalityPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updateFunctionalityPointAccess"
            component={UpdateFunctionalityPointAccess}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewPointAccess"
            component={PreviewPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createPointAccess"
            component={CreatePointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updatePointAccess"
            component={UpdatePointAccess}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewVideo"
            component={PreviewVideo}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewActionPointAccess"
            component={PreviewActionPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createActionPointAccess"
            component={CreateActionPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updateActionPointAccess"
            component={UpdateActionPointAccess}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewButtonPointAccess"
            component={PreviewButtonPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/createButtonPointAccess"
            component={CreateButtonPointAccess}
            addHeader
            addSidebar
          />
          <ProtectedRoute
            path="/updateButtonPointAccess"
            component={UpdateButtonPointAccess}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/mktPortalVideoCustomer"
            component={VideoAccountantPreview}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewContractBond"
            component={ContractsPreview}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewService"
            component={ServicePreview}
            addHeader
            addSidebar
          />

          <ProtectedRoute
            path="/previewReportMapContract"
            component={ReportContract}
            addHeader
            addSidebar
          />

          <Redirect to={"/login"} />
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default Routes;
